import { render } from "./LadTableSet.vue?vue&type=template&id=08cb80d4"
import script from "./LadTableSet.vue?vue&type=script&lang=js"
export * from "./LadTableSet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__